// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__gK9KG","search":"Settings_search__1s0vU","filter":"Settings_filter__1muDS"};